var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVolumeDisableIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.682 8.923c1.584 2.515 1.808 5.861.301 8.823m-3.637-7.178c1.337 1.562 1.526 3.642.254 5.482M12 6.844l-4.412 3.488H3v5.023l4.588-.001L12 18.844v-12z",
    stroke: "#87888D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVolumeDisableIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/VolumeDisableIcon.9573c551.svg";
export { ForwardRef as ReactComponent };